import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import { toast } from 'react-toastify';
import Framework from '@beardeddevops/react.framework';
import { isAccountOwnerLogin } from '../../utils/accountAccess';
import {
	addQuickPick,
	fetchQuickPickStatus,
	removeQuickPickByEntity,
} from '../../utils/checkoutQuickPicks';
import './QuickCheckout.scss';

class QuickCheckoutFavoriteStar extends React.Component {
	static propTypes = {
		entityType: PropTypes.string.isRequired,
		entityPkey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		disabled: PropTypes.bool,
		disabledReason: PropTypes.string,
	};

	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			favorited: false,
		};
	}

	componentDidMount() {
		void this.loadStatus();
	}

	componentDidUpdate(prevProps) {
		const entityChanged = prevProps.entityType !== this.props.entityType
			|| String(prevProps.entityPkey) !== String(this.props.entityPkey);
		const ownerLoginChanged = (prevProps.rootState ? prevProps.rootState.user : undefined)
			!== (this.props.rootState ? this.props.rootState.user : undefined);
		const disabledChanged = prevProps.disabled !== this.props.disabled;

		if (entityChanged || ownerLoginChanged || disabledChanged) {
			void this.loadStatus();
		}
	}

	loadStatus = async () => {
		const { entityType, entityPkey, disabled } = this.props;
		if (disabled || !entityPkey) {
			this.setState({ favorited: false, loading: false });
			return;
		}

		this.setState({ loading: true });
		try {
			const status = await fetchQuickPickStatus(entityType, entityPkey);
			const favorited = status && status.favorited;
			this.setState({ favorited: !!favorited, loading: false });
		} catch (error) {
			this.setState({ favorited: false, loading: false });
		}
	};

	handleToggle = async () => {
		const { entityType, entityPkey, disabled } = this.props;
		if (disabled || !entityPkey || this.state.loading) {
			return;
		}

		this.setState({ loading: true });
		try {
			if (this.state.favorited) {
				await removeQuickPickByEntity(entityType, entityPkey);
				this.setState({ favorited: false, loading: false });
				toast.info('Removed from Quick Checkout favorites.', { position: toast.POSITION.TOP_RIGHT });
			} else {
				await addQuickPick(entityType, entityPkey);
				this.setState({ favorited: true, loading: false });
				toast.success('Added to Quick Checkout favorites.', { position: toast.POSITION.TOP_RIGHT });
			}
		} catch (error) {
			this.setState({ loading: false });
			const message = (error && error.responseJSON && error.responseJSON.response)
				|| 'Could not update Quick Checkout favorite.';
			toast.error(message, { position: toast.POSITION.TOP_RIGHT });
		}
	};

	render() {
		if (!isAccountOwnerLogin(this.props.rootState)) {
			return null;
		}

		const { disabled, disabledReason } = this.props;
		const { favorited, loading } = this.state;
		const title = disabled && disabledReason
			? disabledReason
			: (
				favorited
					? 'Remove from Quick Checkout favorites. Reorder favorites in Settings → Quick Checkout.'
					: 'Add to Quick Checkout favorites. Reorder favorites in Settings → Quick Checkout.'
			);

		return (
			<Tooltip title={title} arrow placement="top">
				<span className="quick-checkout-favorite-star">
					<IconButton
						size="small"
						onClick={this.handleToggle}
						disabled={disabled || loading || !this.props.entityPkey}
						aria-label={favorited ? 'Remove quick checkout favorite' : 'Add quick checkout favorite'}
					>
						<i className={favorited ? 'fa fa-star' : 'fa fa-star-o'} />
					</IconButton>
				</span>
			</Tooltip>
		);
	}
}

export default Framework.Components.withRootState(QuickCheckoutFavoriteStar);
